<template>
  <div>
    <BaseView />
  </div>
</template>

<script>
import BaseView from '@/views/BaseView'

export default {
  name: 'App',
  components: {
    BaseView,
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
  @import "sass/main";
</style>
